import { useHotkeys } from "react-hotkeys-hook";
import { useNavigate } from "react-router-dom";

import { useAuth } from "@/contexts/auth/useAuth";
import { useModalContext } from "@/contexts/modal-context";

export const useGeneralHotkeys = () => {
  const navigate = useNavigate();
  const { openModal } = useModalContext();
  const { currentAccount } = useAuth();

  const handleHotkeyToggleHelp = () => {
    openModal("HOTKEYS");
  };

  const handleHotkeyOpenCompose = () => {
    openModal("COMPOSE");
  };

  const handleHotkeySearch = () => {
    const element = document.querySelector("input#search") as HTMLInputElement;

    if (element) {
      element.focus();
    }
  };

  const handleHotkeyUnfocus = () => {
    const focusedElement = document.activeElement as HTMLElement;

    if (focusedElement) {
      focusedElement.blur();
    }
  };

  const handleHotkeyBack = () => {
    if (window.history && window.history.length === 1) {
      navigate("/");
    } else {
      navigate(-1);
    }
  };

  useHotkeys("?", handleHotkeyToggleHelp, { useKey: true });
  useHotkeys("alt+n", handleHotkeyOpenCompose, { enabled: !!currentAccount });
  useHotkeys("s", handleHotkeySearch, { preventDefault: true });
  useHotkeys("esc", handleHotkeyUnfocus, { enableOnFormTags: true });
  useHotkeys("backspace", handleHotkeyBack);
};
